export const GENERAL_TEXTBOX_SUBTITLE_INPUTS_ALL_TYPE_REQUEST = 'GENERAL_TEXTBOX_SUBTITLE_INPUTS_ALL_TYPE_REQUEST';
export const GENERAL_TEXTBOX_SUBTITLE_INPUTS_ALL_TYPE_SUCCESS = 'GENERAL_TEXTBOX_SUBTITLE_INPUTS_ALL_TYPE_SUCCESS';
export const GENERAL_TEXTBOX_SUBTITLE_INPUTS_ALL_TYPE_FAIL = 'GENERAL_TEXTBOX_SUBTITLE_INPUTS_ALL_TYPE_FAIL';

